export default function CuotasTable({
                                        data = [],
                                        loading,
                                        onAgregarCuota,
                                        onGenerarCuotas,
                                        onEditarCuota,
                                        onEliminarCuota,
                                        onPagar,
                                    }) {
    if (loading) return <p>Cargando cuotas...</p>;

    return (
        <div className="table-wrap">
            <div style={{ marginBottom: 12, display: "flex", gap: 8, flexWrap: "wrap" }}>
                <button className="btn-primary" type="button" onClick={onAgregarCuota}>
                    Agregar cuota
                </button>

                <button className="btn-info" type="button" onClick={onGenerarCuotas}>
                    Generar cuotas
                </button>
            </div>

            <table className="table-app">
                <thead>
                <tr>
                    <th>N°</th>
                    <th>Vencimiento</th>
                    <th>Programado</th>
                    <th>Pagado</th>
                    <th>Estado</th>
                    <th>Acción</th>
                </tr>
                </thead>
                <tbody>
                {data.length === 0 ? (
                    <tr>
                        <td colSpan="6" className="empty-state">
                            No hay cuotas registradas
                        </td>
                    </tr>
                ) : (
                    data.map((row) => (
                        <tr key={row.idCuota}>
                            <td>{row.numeroCuota}</td>
                            <td>{row.fechaVencimiento || "-"}</td>
                            <td>S/ {Number(row.montoProgramado || 0).toFixed(2)}</td>
                            <td>S/ {Number(row.montoPagado || 0).toFixed(2)}</td>
                            <td>{row.estado}</td>
                            <td style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                <button type="button" className="btn-secondary" onClick={() => onEditarCuota(row)}>
                                    Editar
                                </button>

                                <button type="button" className="btn-danger" onClick={() => onEliminarCuota(row)}>
                                    Eliminar
                                </button>

                                {row.estado !== "PAGADA" && (
                                    <button type="button" className="btn-primary" onClick={() => onPagar(row)}>
                                        Pagar
                                    </button>
                                )}
                            </td>
                        </tr>
                    ))
                )}
                </tbody>
            </table>
        </div>
    );
}